import React from "react";

import { ReplaceVirtualTranslationKey } from "../../../../../../helpers";
import { useTranslation } from "../../../../../../hooks";
import { TicketInfo } from "../../../../../../models";
import { MarketListItem } from "./market-list-item";

interface MarketListProps {
  isExpress: boolean;
  ticketStatus: number;
  ticketInfos: Array<TicketInfo>;
}

export const MarketList: React.FC<MarketListProps> = ({
  ticketInfos,
  isExpress,
  ticketStatus,
}) => {

  const t = useTranslation();

  return (
    <div className="bet-section-wrapper">
      <div className="scroll-holder">
        <div className="scrollable-container static-scroll">
          {ticketInfos.map(
            ({
              odds,
              status,
              result,
              roundId,
              numbers,
              betType,
              gameName,
              betAmount,
              winAmount,
              marketName,
              possibleWin,
              combinations,
              translationSymbols,
              possibleCombinations,
            }) => (
              <MarketListItem
                odds={odds}
                status={status}
                result={result}
                key={marketName}
                betType={betType}
                roundId={roundId}
                gameName={gameName}
                isExpress={isExpress}
                betAmount={betAmount}
                winAmount={winAmount}
                possibleWin={possibleWin}
                combinations={combinations}
                possibleCombinations={possibleCombinations}
                marketName={
                  numbers ||
                  ReplaceVirtualTranslationKey(
                    t(translationSymbols?.marketName || marketName),
                    translationSymbols,
                    t,
                  )
                }
                selectionName={ReplaceVirtualTranslationKey(
                  t(translationSymbols?.selectionName),
                  translationSymbols,
                  t,
                )}
                // result={JSON.parse(JSON.parse(result)?.result)}
                handicap={translationSymbols?.handicap}
                ticketStatus={ticketStatus}
              />
            ),
          )}
        </div>
      </div>
    </div>
  );
};
